

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
} from "@mui/material";

import { fetchRejectedRequests } from "../../../contents/redux/actions/trackActions"; // Import the action to fetch completed requests

const RejectedRequests = () => {
  const dispatch = useDispatch();
  const { rejected, isLoading, fetchRejectedError } = useSelector((state) => state.track); // Access the completed requests from the Redux store

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Fetch completed requests on component mount
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    dispatch(fetchRejectedRequests(userId));
  }, [dispatch]);

  // Pagination
  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Paginated completed requests
  const paginatedRequests = rejected.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  if (isLoading) {
    return <div>Loading...</div>; // Display a loading message
  }

  if (fetchRejectedError) {
    return <div>Error: {fetchRejectedError}</div>; // Display an error message
  }

  return (
    <div className="component-wrapper">
      <div className="component-title">Rejected Requests</div>
      <div className="wrapper">
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell>Request Type</TableCell>
                <TableCell>Requester</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date Created</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRequests.map((request, index) => (
                <TableRow key={request.id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{request.requestType || "N/A"}</TableCell>
                  <TableCell>{request.requester || "N/A"}</TableCell>
                  <TableCell>{request.statusName || "Completed"}</TableCell>
                  <TableCell>
                    {request.createdOn
                      ? new Date(request.createdOn).toLocaleDateString()
                      : "N/A"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={rejected.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
          />
        </TableContainer>
      </div>
    </div>
  );
};

export default RejectedRequests;
